<template>
  <div class="view--configure-time">

    <div class="home-grid" v-if="tabsLoaded && tabSelected === 0">
      <div class="home-section-container">
        <h2 class="home-section-title">Principal</h2>
        <div class="home-grid-cards">
          <v-card class="home-card" @click="setTabSelected(1)" v-if="workcenter && workcenter.availableSchedule" :elevation="$getCardOptions('elevation')">
            <v-icon size="64" :color="$getColor('vuetifyColor1')">mdi-calendar</v-icon>
            <h3>Cuadrantes</h3>
          </v-card>
          <v-card class="home-card" @click="setTabSelected(3)" :elevation="$getCardOptions('elevation')">
            <v-icon size="64" :color="$getColor('vuetifyColor1')">mdi-clock-outline</v-icon>
            <h3>Fichajes</h3>
          </v-card>
          <v-card class="home-card" @click="setTabSelected(2)" :elevation="$getCardOptions('elevation')">
            <v-icon size="64" :color="$getColor('vuetifyColor1')">mdi-alert-circle</v-icon>
            <h3>Alertas</h3>
            <span class="home-badge" v-if="totalIncidencesLoaded && totalIncidences > 0">{{ totalIncidences }}</span>
          </v-card>
          <v-card class="home-card" @click="setTabSelected(4)" v-if="availableN3" :elevation="$getCardOptions('elevation')">
            <v-icon size="64" :color="$getColor('vuetifyColor1')">mdi-currency-eur</v-icon>
            <h3>Anticipos</h3>
          </v-card>
        </div>
      </div>

      <div class="home-section-container secondary-section">
        <h2 class="home-section-title">Otros</h2>
        <div class="home-grid-cards secondary-grid">
          <CreateClockEntry
            v-if="user && user.worker && worker && workcenter"
            :isAdmin="false"
            :workerId="user.worker"
            :worker="worker"
            buttonStyle="Modern"
            @refreshClockEntries="refreshClockEntries"
          />
          <v-card
            class="home-card modern-clock-btn"
            @click="setTabSelected(5)"
            :elevation="$getCardOptions('elevation')"
          >
            <v-icon size="48" :color="$getColor('vuetifyColor1')">mdi-account-cog</v-icon>
            <h3>Panel de usuario</h3>
          </v-card>
          <v-card class="home-card modern-clock-btn" @click="setTabSelected(6)" :elevation="$getCardOptions('elevation')">
            <v-icon size="48" :color="$getColor('vuetifyColor1')">mdi-calendar-month</v-icon>
            <h3>Calendario</h3>
          </v-card>
        </div>
      </div>
    </div>

    <div class="floating-menu-container" v-if="tabsLoaded && this.$vuetify.breakpoint.width < 1024">
      <nav class="floating-menu" :style="{ '--active-bg': $getColor('vuetifyColor1') }">
        <button
          class="menu-item"
          :class="{ 'active': tabSelected === 1 }"
          @click="setTabSelected(1)"
          v-if="workcenter && workcenter.availableSchedule"
        >
          <div class="icon-wrapper">
            <v-icon :color="tabSelected === 1 ? 'white' : 'grey darken-1'">mdi-calendar</v-icon>
          </div>
          <span class="label">Cuadrantes</span>
        </button>

        <button
          class="menu-item"
          :class="{ 'active': tabSelected === 3 }"
          @click="setTabSelected(3)"
        >
          <div class="icon-wrapper">
            <v-icon :color="tabSelected === 3 ? 'white' : 'grey darken-1'">mdi-clock-outline</v-icon>
          </div>
          <span class="label">Fichajes</span>
        </button>

        <!-- Central Button -->
        <button
          class="menu-item central-action"
          :class="{ 'active': tabSelected === 0 }"
          @click="setTabSelected(0)"
        >
          <div class="icon-wrapper">
            <v-icon :color="tabSelected === 0 ? 'white' : 'grey darken-1'">mdi-view-grid</v-icon>
          </div>
        </button>

        <button
          class="menu-item"
          :class="{ 'active': tabSelected === 2, 'has-alert': tabSelected !== 2 && totalIncidencesLoaded && totalIncidences > 0 }"
          @click="setTabSelected(2)"
        >
          <div class="icon-wrapper">
            <v-icon :color="tabSelected === 2 ? 'white' : 'grey darken-1'">mdi-alert-circle</v-icon>
            <span class="badge" v-if="tabSelected !== 2 && totalIncidencesLoaded && totalIncidences > 0">{{ totalIncidences }}</span>
          </div>
          <span class="label">Alertas</span>
        </button>

        <button
          class="menu-item"
          :class="{ 'active': tabSelected === 4 }"
          @click="setTabSelected(4)"
          v-if="availableN3"
        >
          <div class="icon-wrapper">
            <v-icon :color="tabSelected === 4 ? 'white' : 'grey darken-1'">mdi-currency-eur</v-icon>
          </div>
          <span class="label">Anticipos</span>
        </button>

        <button
          class="menu-item"
          :class="{ 'active': tabSelected === 6 }"
          @click="setTabSelected(6)"
        >
          <div class="icon-wrapper">
            <v-icon :color="tabSelected === 6 ? 'white' : 'grey darken-1'">mdi-calendar-month</v-icon>
          </div>
          <span class="label">Calendario</span>
        </button>
      </nav>
    </div>

    <!-- Desktop Navigation Drawer for ROLE_TRABAJADOR -->
    <v-navigation-drawer v-if="tabsLoaded && user && user.rol === 'ROLE_TRABAJADOR' && this.$vuetify.breakpoint.width >= 1024"
      v-model="drawer" :mini-variant="mini"
      permanent
      app>
      <v-list-item class="px-2" @click="mini = !mini">
        <v-list-item-avatar>
          <v-avatar :color="$getColor('vuetifyColor1')" size="30">
            <span class="white--text text-h6">{{ userChar }}</span>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-title>
          <div>
            <span>{{ user.sub || user.name || '' }}</span>
          </div>
        </v-list-item-title>
        <v-btn icon @click.stop="mini = !mini">
          <v-icon>{{ drawer && mini ? "mdi-menu" : "mdi-menu-open" }}</v-icon>
        </v-btn>
      </v-list-item>

      <v-divider></v-divider>

      <v-list nav dense>
        <v-list-item @click="setTabSelected(0)" link :color="$getColor('vuetifyColor1')" :input-value="tabSelected === 0">
          <v-list-item-icon>
            <v-icon>mdi-view-grid</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Inicio</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="setTabSelected(1)" v-if="workcenter && workcenter.availableSchedule" link :color="$getColor('vuetifyColor1')" :input-value="tabSelected === 1">
          <v-list-item-icon>
            <v-icon>mdi-calendar</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Cuadrantes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="setTabSelected(3)" link :color="$getColor('vuetifyColor1')" :input-value="tabSelected === 3">
          <v-list-item-icon>
            <v-icon>mdi-clock-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Fichajes</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="setTabSelected(2)" link :color="$getColor('vuetifyColor1')" :input-value="tabSelected === 2">
          <v-list-item-icon>
            <v-badge :content="totalIncidences" :value="totalIncidencesLoaded && totalIncidences > 0" color="red" overlap>
              <v-icon>mdi-alert-circle</v-icon>
            </v-badge>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Alertas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="setTabSelected(4)" v-if="availableN3" link :color="$getColor('vuetifyColor1')" :input-value="tabSelected === 4">
          <v-list-item-icon>
            <v-icon>mdi-currency-eur</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Anticipos</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="setTabSelected(5)" link :color="$getColor('vuetifyColor1')" :input-value="tabSelected === 5">
          <v-list-item-icon>
            <v-icon>mdi-account-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Panel de usuario</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item @click="setTabSelected(6)" link :color="$getColor('vuetifyColor1')" :input-value="tabSelected === 6">
          <v-list-item-icon>
            <v-icon>mdi-calendar-month</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Calendario</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <div class="left-side" v-show="tabSelected !== 0">
      <CreateClockEntry v-if="user && user.worker && worker && workcenter&& (tabSelected===3 )"
      :isAdmin="false" :workerId="user.worker" :worker="worker" @refreshClockEntries="refreshClockEntries" :embedded="true"></CreateClockEntry>
      <section-header v-if="workcenter && workcenter.availableSchedule"
       v-show="tabSelected===1" first="Selecciona la fecha, elige el turno" second="y añade tus códigos" />
      <section-header v-show="tabSelected===2" first="A continuación," second="las incidencias abiertas" />
      <div class="row-month-selection" v-show="tabSelected===3">
        <v-btn @click="substractMonthSelected()" icon :dark="$getPrimaryButton('dark')" depressed :rounded="$getPrimaryButton('rounded')"
        :outlined="true" :color="$getPrimaryButton('color')" class="mr-3">
        <v-icon>mdi-arrow-left-bold</v-icon>
      </v-btn>
        <section-header  first="Lista de" :second="'fichajes del mes de ' + getMonthName(this.selectedMonth + 1)" />
        <v-btn @click="addMonthSelected()" icon :dark="$getPrimaryButton('dark')" depressed :rounded="$getPrimaryButton('rounded')"
        :outlined="true" :color="$getPrimaryButton('color')" class="ml-3">
        <v-icon>mdi-arrow-right-bold</v-icon>
      </v-btn>
      </div>
      <WorkerClockEntries v-show="tabSelected===3" ref="workerClockEntries" />
      <v-date-picker v-if="workcenter && workcenter.availableSchedule" v-show="tabSelected===1" v-model="itemData.eventTime"
      :picker-date.sync="pickerYearMonth" locale="es"
      first-day-of-week="1" :min="minDate" :max="maxDate" :events="functionEvents"
      @update:picker-date="onPickerDateChange" @change="applyHolidayBackgrounds">
      </v-date-picker>
      <mdtec-panel v-show="tabSelected===2">
        <template v-slot:title> Incidencias </template>
        <template v-slot:content>
          <Incidences v-if="user && user.worker" :isLogged="true" @updateTotal="updateTotalIncidences"/>
        </template>
      </mdtec-panel>
      <!-- N3 Anticipo -->
      <div v-show="tabSelected===4" v-if="availableN3">
        <section-header first="Solicitar" second="Anticipo" />

        <v-card
          outlined
          class="d-flex flex-column align-center justify-center p-4 mb-6 text-center mx-auto"
          :elevation="$getCardOptions('elevation')"
          style="border-radius: 24px; max-width: 600px; width: 100%; background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(10px); border: 1px solid rgba(0, 0, 0, 0.08);"
        >
          <v-icon :color="$getColor('vuetifyColor1')" size="48" class="mb-3">mdi-information-outline</v-icon>
          <h3 class="mb-2" :style="{ color: '#555', fontWeight: '600' }">
            Plazo de Solicitud de Anticipos
          </h3>
          <p class="text-body-2 mb-4 text--secondary px-4" style="line-height: 1.6;">
            El plazo límite para solicitar el anticipo mensual es hasta el <strong>día 8 de cada mes</strong> (inclusive). A partir del día 9, solo podrá registrar solicitudes para los meses futuros.
          </p>
          <CreateN3Entry v-if="user && user.worker" :isAdmin="false" :selectedYear="currentYear" @entryAdded="refreshN3Entries"></CreateN3Entry>
        </v-card>

        <N3WorkerTable v-if="user && user.worker" :workerId="user.worker" :selectedYear="currentYear" :showDetails="false" :showObservations="false" ref="n3WorkerTable" />
      </div>
      <!-- N3 Anticipo end -->
      <!-- Worker Panel -->
      <div v-show="tabSelected===5">
        <section-header first="Tu información" second="Panel de usuario" />
        <WorkerInfo v-if="worker" :worker="worker" />
      </div>
      <!-- Worker Panel end -->
      <!-- Calendario -->
      <div v-if="tabSelected===6">
        <section-header first="Calendario" second="Centro de Trabajo" />
        <WorkCenterCalendar />
      </div>
      <!-- Calendario end -->
    </div>

    <div class="right-side" v-show="tabSelected===1 && tabSelected !== 0" v-if="workcenter && workcenter.availableSchedule">
      <div class="panel-loader" v-if="loading">
        <v-progress-circular indeterminate :color="$getColor('vuetifyColor1')"></v-progress-circular>
      </div>

      <div class="check-buttons" v-show="!loading">
        <div class="option-selector--container field-group">
          <label class="option-selector--label field-group--label" for=""
            >Tipo de turno <span class='blocked-text' v-if="isBlocked">(Día bloqueado)</span></label
          >
          <v-tooltip bottom v-if="!isBlocked">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  color="primary"
                  class="mb-2 ml-2"
                  dark
                  x-large
                  icon
                  @click="selectBlank()"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-refresh-circle</v-icon>
                </v-btn>
              </template>
              <span>Reiniciar día</span>
            </v-tooltip>
          <div class="check-buttons--list">
            <check-selector v-show="!loading" title="Turno de mañana" subtitle=""
              ref="morningSelector" v-on:click.native="selectMorning" color="blue"
              :disabled="isBlocked" />
            <check-selector v-show="!loading" title="Turno de tarde" subtitle="" ref="eveningSelector"
              v-on:click.native="selectEvening" color="yellow" :disabled="isBlocked" />
            <check-selector v-show="!loading" title="Turno de noche" subtitle="" ref="nightSelector"
              v-on:click.native="selectNight" color="red" :disabled="isBlocked" />
            <check-selector v-show="!loading" title="Otro" subtitle="" ref="otherSelector"
              v-on:click.native="selectOther" color="purple" :disabled="isBlocked" />
            <check-selector v-show="!loading" title="Ausencia/Baja" subtitle="" ref="absenceSelector"
              v-on:click.native="selectAbsence" color="green" :disabled="isBlocked" />
              <check-selector v-show="!loading" title="Guardia" subtitle="" ref="guardSelector"
              v-on:click.native="selectGuard" color="orange" :disabled="isBlocked" />
          </div>
        </div>
      </div>
      <div class="codes-containter">
        <div
          class="option-selector--container field-group"
          v-if="optionsSelected && optionsSelected.codes.length > 0 && adminCodeListAvailable"
        >
          <label class="option-selector--label field-group--label" for=""
            >Códigos de Administración <span class='blocked-text' v-if="isBlocked">(Día bloqueado)</span></label
          >
          <div class="field-grid">
            <selection-card v-for="item in optionsSelected.codes"
              v-show="item.autoVariable || item.admin" :key="item.id" :name="item.name"
              :class="item.autoVariable ? 'swiper-slide customGreen' : 'swiper-slide customPurple'"
              size="large"
              :description="item.code"
              selected
              :disableMouse="true"
            />
          </div>
        </div>
        <div
          class="option-selector--container field-group"
          v-if="optionsSelected && optionsSelected.codes.length > 0 && codeListAvailable"
        >
          <label class="option-selector--label field-group--label" for=""
            >Tu lista de códigos <span class='blocked-text' v-if="isBlocked">(Día bloqueado)</span></label
          >
          <div class="field-grid">
            <selection-card
              v-for="item in optionsSelected.codes"
              v-show="!item.extraHour && !item.autoVariable && !item.admin"
              :key="item.id"
              :name="item.name"
              :class="[
                item.autoVariable ? 'swiper-slide customGreen' : 'swiper-slide customRed',
                { 'custom-disabled-card-clickable': isCodeDisabled(item) }
              ]"
              size="large"
              :description="item.code"
              v-on:click.native="setValue(item)"
              selected
              :disable-mouse="isBlocked"
            />
          </div>
        </div>
        <div class="option-selector--container field-group"
            v-if="optionsSelected && optionsSelected.codes && optionsSelectedWithExtraHours.codes.length > 0">
            <label class="option-selector--label field-group--label" for="">Códigos de unidades</label>
            <div class="field-grid dir-column">
              <div class="field-grid--row" v-for="(item, key) in optionsSelectedWithExtraHours.codes" :key="item.id">
                <selection-card :key="item.id" :name="item.name"
                  :class="['swiper-slide customRed', { 'custom-disabled-card-clickable': isCodeDisabled(item) }]"
                  size="large" :description="item.code" v-on:click.native="setValue(item)" selected :disable-mouse="isBlocked"/>
                <v-text-field v-model="optionsSelected.extraHours[key]" label="Nº de unidades"
                  type="number" min="0.5" max="24" step="0.5" outlined
                  :error="!optionsSelected.extraHours[key] || Number(optionsSelected.extraHours[key]) <= 0"
                  :error-messages="(!optionsSelected.extraHours[key] || Number(optionsSelected.extraHours[key]) <= 0) ? 'El número de unidades debe ser mayor que 0' : []"
                  hide-details="auto" :disabled="isBlocked"></v-text-field>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn small  :dark="$getPrimaryButton('dark')"
                      :rounded="$getPrimaryButton('rounded')" :outlined="$getPrimaryButton('outlined')"
                      :color="$getPrimaryButton('color')" v-bind="attrs" v-on="on" v-if="!isBlocked"
                      @click="updateCodes()">
                      <v-icon left small>check_circle</v-icon> GUARDAR
                    </v-btn>
                  </template>
                  <span>Guardar unidades</span>
                </v-tooltip>
              </div>
            </div>
          </div>
        <div
          class="option-selector--container field-group"
          v-if="options && optionsRecommended.length > 0 && !isBlocked"
        >
          <label class="option-selector--label field-group--label" for=""
            >Códigos sugeridos</label
          >
          <div class="field-grid">
            <selection-card v-for="item in optionsRecommended" :key="item.id" :name="item.name"
              :class="['swiper-slide', { 'custom-disabled-card': isCodeDisabled(item) }]"
              size="large" :description="item.code"
              v-on:click.native="setValue(item)" :selected="checkValue(item.id)"
              :disable-mouse="isBlocked || updatingCodes || isCodeDisabled(item)" />
          </div>
        </div>
        <div class="option-selector--container field-group"
          v-if="optionsExtra.length > 0 && !isBlocked">
          <label class="option-selector--label field-group--label" for="">Añade más códigos</label>
          <div class="field-grid">
            <selection-card v-for="item in optionsExtra" :key="item.id" :name="item.name"
              :class="['swiper-slide', { 'custom-disabled-card': isCodeDisabled(item) }]"
              size="large" :description="item.code"
              v-on:click.native="setValue(item)" :selected="checkValue(item.id)"
              :disable-mouse="isBlocked || updatingCodes || isCodeDisabled(item)" />
          </div>
        </div>
      </div>
    </div>
    <div class="right-side mt-4" v-show="tabSelected===3 && tabSelected !== 0">
      <section-header first="Selecciona el mes" second="y descarga los datos" />
      <v-btn :dark="$getPrimaryButton('dark')" depressed :rounded="$getPrimaryButton('rounded')"
        :outlined="true" :color="$getPrimaryButton('color')" large
        @click="downloadClockEntries()" class="my-2 mr-2" >
        <v-icon left>mdi-download</v-icon>Descargar
      </v-btn>
      <CreateClockEntryManual  v-if="user && user.worker && worker && workcenter"
      :isAdmin="false" :workerId="user.worker" :worker="worker" @refreshClockEntries="refreshClockEntries"></CreateClockEntryManual >
    </div>
  </div>
</template>

<script>
import authService from '@/services/auth.service';

import SectionHeader from '@/components/Headers/SectionHeader.vue';
import CheckSelector from '@/components/Buttons/CheckSelector.vue';
import SelectionCard from '@/components/Cards/CodeCard.vue';
import MdtecPanel from '@/components/Cards/MdtecPanel.vue';
import Incidences from '@/views/_FATDA/components/Incidences.vue';

import CreateClockEntry from '@/views/_FATDA/components/CreateClockEntry.vue';
import CreateClockEntryManual from '@/views/_FATDA/components/CreateClockEntryManual.vue';
import CreateN3Entry from '@/views/_FATDA/components/CreateN3Entry.vue';
import N3WorkerTable from '@/views/_FATDA/components/N3WorkerTable.vue';

import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

import ConfigureTime from '@/services/configure-time.service';
import scheduleService from '@/services/schedule.service';
import clockEntryService from '@/services/clockentry.service';
import loggedUserService from '@/services/logged-user.service';

import moment from 'moment';
import WorkCenterCalendarService from '@/services/workcenter-calendar.service';

import WorkerClockEntries from '@/views/_FATDA/components/WorkerClockEntries.vue';
import WorkerInfo from '@/views/_FATDA/components/WorkerInfo.vue';
import WorkCenterCalendar from '@/views/_FATDA/WorkCenterCalendar.vue';

export default {
  name: 'configure-time',
  mixins: [validationMixin],
  components: {
    SectionHeader,
    CheckSelector,
    SelectionCard,
    MdtecPanel,
    Incidences,
    CreateClockEntry,
    CreateClockEntryManual,
    CreateN3Entry,
    WorkerClockEntries,
    N3WorkerTable,
    WorkerInfo,
    WorkCenterCalendar,
  },
  data: () => ({
    user: null,
    itemData: {
      type: null,
      eventTime: null,
    },
    // minDate = first day of current month
    minDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 2).toISOString(),
    // maxDate = last day of the month
    maxDate: new Date(new Date().getFullYear(), new Date().getMonth() + 2, 1).toISOString(),

    // selectedMonth
    selectedMonth: new Date().getMonth(),

    modal: false,
    loading: false,
    updatingCodes: false,

    options: null,
    selectedDate: null,
    worker: null,
    workcenter: null,
    n2current: [],
    tabSelected: 0,
    tabsLoaded: false,
    totalIncidences: null,
    totalIncidencesLoaded: false,

    drawer: true,
    mini: false,

    clockEntriesCurrent: [],
    currentYear: new Date().getFullYear(),
    calendarEntries: [],
    pickerYearMonth: null,
    pickerObserver: null,

  }),
  mounted() {
    this.user = authService.getDecodedJwtToken(this.$store.state.auth.user);
    if (this.user.worker) {
      this.getWorkCenter();
      this.getWorker();
      this.getSchedule();
      this.setupPickerObserver();
    } else {
      this.$router.push({ name: 'Home' });
    }
  },
  beforeDestroy() {
    if (this.pickerObserver) {
      this.pickerObserver.disconnect();
    }
  },
  computed: {
    userChar() {
      if (this.user && this.user.sub) {
        return this.user.sub.substring(1, 0).toUpperCase();
      }
      return 'A';
    },
    isBlocked: {
      get() {
        const tempSelected = this.n2current[
          this.n2current.findIndex((item) => item.date === this.selectedDate)
        ];
        if (tempSelected) {
          return tempSelected.blocked;
        }
        return null;
      },
      set() {
        const tempSelected = this.n2current[
          this.n2current.findIndex((item) => item.date === this.selectedDate)
        ];
        if (tempSelected) {
          tempSelected.blocked = !tempSelected.blocked;
        }
      },
    },
    optionsSelected() {
      const tempSelected = this.n2current[this.n2current.findIndex((item) => item.date === this.selectedDate)];
      // order by code.id
      if (tempSelected) {
        tempSelected.codes.sort((a, b) => a.id - b.id);
      }
      return tempSelected;
    },
    optionsSelectedWithExtraHours() {
      if (!this.optionsSelected) {
        return null;
      }
      // create a copy of optionsSelected to avoid modifying the original object
      const optionsSelectedCopy = JSON.parse(JSON.stringify(this.optionsSelected));
      // return items in optionsSelected with extraHours equal to true
      optionsSelectedCopy.codes = optionsSelectedCopy.codes.filter((item) => item.extraHour);
      optionsSelectedCopy.codes.sort((a, b) => a.id - b.id);
      return optionsSelectedCopy;
    },
    optionsRecommended() {
      let newOptions = [];
      if (!this.optionsSelected || !this.options) {
        return newOptions;
      }
      if (this.optionsSelected.type === 'ABSENCE') {
        newOptions = this.options;
        return newOptions;
      }
      if (this.optionsSelected.type === 'NIGHT') {
        newOptions = this.options.filter((item) => item.type === 'all' || item.type === 'night');
      } else if (this.optionsSelected.type === 'EVENING' || this.optionsSelected.type === 'MORNING') {
        newOptions = this.options.filter((item) => item.type === 'all' || item.type === 'morning/evening');
      } else if (this.optionsSelected.type === 'OTHER') {
        // newOptions = this.options.filter((item) => item.extraHour === false);
        newOptions = this.options.filter((item) => item.code === '2007' || item.code === '2095' || item.code === '2002'
        || item.code === '2017' || item.code === '2386' || item.code === '2343');
      } else if (this.optionsSelected.type === 'GUARD') {
        // newOptions = this.options.filter((item) => item.extraHour === false);
        newOptions = this.options.filter((item) => item.code === '2007' || item.code === '2095' || item.code === '2002'
        || item.code === '2587' || item.code === '2044' || item.code === '2541' || item.code === '2387');
      }
      const isWeekend = this.isWeekendOrHoliday(this.itemData.eventTime);
      // if isWeekend true, exclude all items with weekend: false
      if (isWeekend) {
        newOptions = newOptions.filter((item) => item.weekend !== '0');
      } else {
        newOptions = newOptions.filter((item) => item.weekend !== '1');
      }

      // exclude items with autoVariation: true or admin:true
      newOptions = newOptions.filter((item) => item.autoVariation !== true && item.admin !== true);
      // newOptions = newOptions.filter((item) => item.autoVariable !== true);

      return newOptions;
    },
    optionsExtra() {
      const newOptions = [];
      if (!this.optionsSelected || !this.options) {
        return newOptions;
      }
      this.options.forEach((item) => {
        if (this.optionsRecommended.indexOf(item) === -1) {
          // if item.autoVariable is true, add it to the list
          if (!item.autoVariable && !item.admin) {
            newOptions.push(item);
          }
        }
      });
      // if optionsSelected.type is other, remove all items with extraHour: true
      if (this.optionsSelected.type === 'OTHER') {
        // return newOptions.filter((item) => item.extraHour === false);
        return newOptions.filter((item) => item.code === '2007' || item.code === '2095' || item.code === '2002');
      }

      if (this.optionsSelected.type === 'GUARD') {
        // return newOptions.filter((item) => item.extraHour === false);
        return newOptions.filter((item) => item.code === '2007' || item.code === '2095' || item.code === '2002'
        || item.code === '2587' || item.code === '2044' || item.code === '2541' || item.code === '2387');
      }

      // exclude items with autoVariation: true
      return newOptions;
    },
    codeListAvailable() {
      // if optionsSelected is null or length is 0, return false
      if (!this.optionsSelected || this.optionsSelected.codes.length === 0) {
        return false;
      }
      // if optionsSelected is not null and length is greater than 0, if there is at least one item with !item.extraHour && !item.autoVariable && !item.admin
      // return true
      return this.optionsSelected.codes.some((item) => !item.extraHour && !item.autoVariable && !item.admin);
    },
    adminCodeListAvailable() {
      // if optionsSelected is null or length is 0, return false
      if (!this.optionsSelected || this.optionsSelected.codes.length === 0) {
        return false;
      }
      return this.optionsSelected.codes.some((item) => item.autoVariable || item.admin);
    },
    availableN3() {
      if (!this.workcenter) {
        return false;
      }
      return this.workcenter.availableN3;
    },
  },

  watch: {
    // watch changes on itemData.eventTime
    'itemData.eventTime': {
      handler() {
        this.getCurrentN2();
        this.applyHolidayBackgrounds();
      },
      deep: true,
    },
    tabSelected(newVal) {
      if (newVal === 1) {
        this.setupPickerObserver();
      }
    },
    // watch changes on itemData.type
    'itemData.type': {
      handler() {
        this.updateData();
      },
      deep: true,
    },
    n2current: {
      handler() {
        this.updateCodes();
      },
      deep: true,
    },
    selectedMonth: {
      handler() {
        this.updateClockEntries();
      },
      deep: true,
    },
  },
  validations() {
    const valObj = {
      itemData: {
        type: { required },
        eventTime: { required },
        totalOnSelectedDate: {
          // check if totalOnSelectedDate is less than 10
          lessThan: (val) => val < 6,
        },
      },
    };
    return valObj;
  },
  methods: {

    getWorker() {
      loggedUserService.getWorker().then((response) => {
        this.worker = response;
      });
    },

    getWorkCenter() {
      loggedUserService.getWorkCenter().then((response) => {
        this.workcenter = response;
        // Ensure workcenter is set in store for other components (like Calendar)
        this.$store.commit('setProject', {
          value: response.id,
          text: response.name,
          availableSchedule: response.availableSchedule,
          availableClockEntries: response.availableClockEntries,
          availableN3: response.availableN3,
        });
        this.tabSelected = 0;
        this.tabsLoaded = true;
        this.fetchCalendarEntries();
      });
    },

    getSchedule() {
      this.loading = true;
      const dateFrom = new Date(this.minDate).toISOString().split('T')[0];
      const dateTo = new Date(this.maxDate).toISOString().split('T')[0];
      scheduleService.getDaysInRange(this.user.worker, dateFrom, dateTo).then((response) => {
        this.n2current = response;
        this.loading = false;
      });
      this.refreshClockEntries();
    },

    refreshClockEntries() {
      const dateRange = clockEntryService.getDateTimeRange(this.selectedMonth, 'MM');
      clockEntryService.getClockEntriesInRange(this.user.worker, dateRange.dateFrom, dateRange.dateTo).then((response) => {
        this.clockEntriesCurrent = response;
        this.updateRangeClockEntries();
      });
    },

    refreshN3Entries() {
      this.$nextTick(() => {
        if (this.$refs.n3WorkerTable) this.$refs.n3WorkerTable.fetchEntries();
      });
    },

    updateClockEntries() {
      const dateRange = clockEntryService.getDateTimeRange(this.selectedMonth, 'MM');
      clockEntryService.getClockEntriesInRange(this.user.worker, dateRange.dateFrom, dateRange.dateTo).then((response) => {
        this.clockEntriesCurrent = response;
        this.updateRangeClockEntries();
      });
    },

    functionEvents(date) {
      const index = this.n2current.findIndex((item) => item.date === date);
      if (index !== -1) {
        if (this.n2current[index].type === 'ABSENCE') {
          return ['#03fc73'];
        } if (this.n2current[index].type === 'MORNING') {
          return ['#00B0FF'];
        } if (this.n2current[index].type === 'EVENING') {
          return ['#FFEB3B'];
        } if (this.n2current[index].type === 'NIGHT') {
          return ['#FF4081'];
        } if (this.n2current[index].type === 'OTHER') {
          return ['#BD45D1'];
        } if (this.n2current[index].type === 'GUARD') {
          return ['#BD45D1'];
        }
        return [];
      }
      return [];
    },

    getCurrentN2() {
      this.selectedDate = this.itemData.eventTime;
      this.type = null;
      this.resetData();
      this.checkAvailability();
      this.n2 = this.n2current.filter((item) => item.date === this.itemData.eventTime);
      if (this.n2.length > 0) {
        if (this.optionsSelected && this.optionsSelected.type) {
          this.selectData(this.optionsSelected.type);
        }
      } else {
        // add new item to n2current
        this.loading = true;
        scheduleService.addDayToWorkerSchedule(
          this.user.worker,
          {
            date: this.itemData.eventTime,
            type: null,
            codes: [],
          },
        ).then(() => {
          this.getSchedule();
        });
      }
    },
    getMonthName(numeroMes) {
      // Verificar si el número de mes está dentro del rango válido (1 a 12)
      if (numeroMes >= 1 && numeroMes <= 12) {
      // Crear una instancia de Date con el año actual y el número de mes proporcionado
        const fecha = new Date(new Date().getFullYear(), numeroMes - 1, 1); // Restar 1 al número de mes (0-indexed)
        // Obtener el nombre del mes en español utilizando toLocaleString()
        const nombreMes = fecha.toLocaleString('es-ES', { month: 'long' });
        return nombreMes.charAt(0).toUpperCase() + nombreMes.slice(1); // Capitalizar la primera letra del nombre del mes
      }
      return 'Mes inválido'; // Manejar casos fuera del rango
    },

    addMonthSelected() {
      this.selectedMonth += 1;
    },
    substractMonthSelected() {
      this.selectedMonth -= 1;
    },

    updateCodes() {
      if (!this.loading && !this.updatingCodes && this.optionsSelected && this.optionsSelected.id && !this.isBlocked) {
        const hasInvalidExtraHours = this.optionsSelected.extraHours && this.optionsSelected.extraHours.some(
          (val) => val === null || val === undefined || val === '' || Number(val) <= 0,
        );
        if (hasInvalidExtraHours) {
          return;
        }
        this.updatingCodes = true;
        scheduleService.updateDay(this.optionsSelected.id, this.optionsSelected).then(() => {
          this.updatingCodes = false;
        });
      }
    },
    updateRangeClockEntries() {
      const eventsCl = [];
      // items foreach
      this.clockEntriesCurrent.forEach((item) => {
        eventsCl.push({
          id: item.id,
          blocked: false,
          start: new Date(item.clockInTime),
          end: new Date(item.clockInTime),
          date: item.clockInTime,
          unixClockInTime: item.unixClockInTime,
          sourceType: item.type,
          manualEntry: item.manualEntry,
          adminEntry: item.adminEntry,
          time: clockEntryService.unixTimeToDateTime(item.unixClockInTime),
          timeLocale: clockEntryService.unixTimeToLocaleDateTime(item.unixClockInTime),
          type: item.type ? this.$getclockEntryTypeValues(item.type).label : 'N/A',
          color: item.type ? this.$getclockEntryTypeValues(item.type).color : 'grey',
          timed: false,
          icon: item.type ? this.$getclockEntryTypeValues(item.type).icon : 'mdi-clock',
          workerId: item.worker.id,
          workerName: item.worker.name,
          workerLastName: item.worker.lastName1,
          workerEmail: item.worker.email,
        });
      });
      this.eventsClock = eventsCl;
      this.$refs.workerClockEntries.updateSchedule(eventsCl, this.worker);
    },

    setValue(item) {
      // check if code is disabled for this day and is not already selected (to allow deselecting)
      if (this.isCodeDisabled(item) && !this.checkValue(item.id)) {
        return;
      }
      // check if item is already selected
      if (this.checkValue(item.id)) {
        if (item.extraHour) {
          this.updateRemoveOptionsSelectedExtraHours(item);
        }
        // remove item from optionsSelected
        this.optionsSelected.codes.splice(
          this.optionsSelected.codes.findIndex((i) => i.id === item.id),
          1,
        );
        // add item to options
        this.options.push(item);
      } else {
        // add item to optionsSelected
        this.optionsSelected.codes.push(item);
        // remove item from options
        this.options = this.options.filter((i) => i.id !== item.id);
        // check if item is extrahours
        if (item.extraHour) {
          this.updateOptionsSelectedExtraHours(item);
        }
      }
    },
    updateOptionsSelectedExtraHours(item) {
      // check if itemSelectedWithExtraHours has already items
      if (this.optionsSelectedWithExtraHours.codes.length > 0) {
        // optionsSelectedWithExtraHours is an array ordered by id
        // check the position of the new item
        const index = this.optionsSelectedWithExtraHours.codes.findIndex((i) => i.id === item.id);
        // add new item to the optionsSelected.extraHours[key]
        if (index === -1) {
          // add new item to the end of the array with value 0
          this.optionsSelected.extraHours.push(0);
        } else {
          // add new item to the position of the array with value 0
          this.optionsSelected.extraHours.splice(index, 0, 0);
        }
      }
    },
    updateRemoveOptionsSelectedExtraHours(item) {
      // check if itemSelectedWithExtraHours has already items
      if (this.optionsSelectedWithExtraHours.codes.length > 0) {
        // optionsSelectedWithExtraHours is an array ordered by id
        // check the position of the item
        const index = this.optionsSelectedWithExtraHours.codes.findIndex((i) => i.id === item.id);
        // remove item from the optionsSelected.extraHours[key]
        if (index !== -1) {
          this.optionsSelected.extraHours.splice(index, 1);
        }
      }
    },
    checkValue(id) {
      // check if item is already selected
      return !!(this.optionsSelected.codes.find((item) => item.id === id));
    },

    updateData() {
      if (this.itemData && this.itemData.type) {
        this.optionsSelected.type = this.itemData.type;
      }
      if (this.itemData.type === 'ABSENCE') {
        this.allOptions = ConfigureTime.getAbsencesOptionsForUser(this.worker.n2Codes);
        this.optionsSelected.codes = this.optionsSelected.codes.filter((item) => this.allOptions.find((i) => i.id === item.id));
        // filter options to remove already selected items
        this.options = this.allOptions.filter((item) => !this.checkValue(item.id));
      } else if (this.itemData.type === 'MORNING' || this.itemData.type === 'EVENING'
      || this.itemData.type === 'NIGHT' || this.itemData.type === 'OTHER' || this.itemData.type === 'GUARD') {
        this.allOptions = ConfigureTime.getVariablesOptionsForUser(this.worker.n2Codes);
        this.optionsSelected.codes = this.optionsSelected.codes.filter((item) => this.allOptions.find((i) => i.id === item.id));
        // filter options to remove already selected items
        this.options = this.allOptions.filter((item) => !this.checkValue(item.id));
      } else {
        this.allOptions = [];
      }
    },
    selectData(type) {
      if (type === 'MORNING') {
        this.selectMorning();
      } else if (type === 'EVENING') {
        this.selectEvening();
      } else if (type === 'ABSENCE') {
        this.selectAbsence();
      } else if (type === 'NIGHT') {
        this.selectNight();
      } else if (type === 'OTHER') {
        this.selectOther();
      } else if (type === 'GUARD') {
        this.selectGuard();
      }
    },
    // check availability
    checkAvailability() {
      this.loading = true;
      this.$refs.morningSelector.updateEnabled(true);
      this.$refs.eveningSelector.updateEnabled(true);
      this.$refs.nightSelector.updateEnabled(true);
      this.$refs.absenceSelector.updateEnabled(true);
      this.$refs.otherSelector.updateEnabled(true);

      this.$refs.guardSelector.updateEnabled(true);
      this.loading = false;
    },

    resetData() {
      this.options = null;
      this.itemData.type = null;
      this.$refs.morningSelector.updateSelected(false);
      this.$refs.eveningSelector.updateSelected(false);
      this.$refs.nightSelector.updateSelected(false);
      this.$refs.absenceSelector.updateSelected(false);
      this.$refs.morningSelector.updateEnabled(false);
      this.$refs.eveningSelector.updateEnabled(false);
      this.$refs.nightSelector.updateEnabled(false);
      this.$refs.absenceSelector.updateEnabled(false);
      this.$refs.otherSelector.updateEnabled(false);

      this.$refs.guardSelector.updateSelected(false);
      this.$refs.guardSelector.updateEnabled(false);
    },

    selectMorning() {
      this.itemData.type = 'MORNING';
      this.$refs.morningSelector.updateSelected(true);
      this.$refs.eveningSelector.updateSelected(false);
      this.$refs.nightSelector.updateSelected(false);
      this.$refs.absenceSelector.updateSelected(false);
      this.$refs.otherSelector.updateSelected(false);

      this.$refs.guardSelector.updateSelected(false);
    },
    selectEvening() {
      this.itemData.type = 'EVENING';
      this.$refs.eveningSelector.updateSelected(true);
      this.$refs.morningSelector.updateSelected(false);
      this.$refs.nightSelector.updateSelected(false);
      this.$refs.absenceSelector.updateSelected(false);
      this.$refs.otherSelector.updateSelected(false);

      this.$refs.guardSelector.updateSelected(false);
    },
    selectNight() {
      this.itemData.type = 'NIGHT';
      this.$refs.nightSelector.updateSelected(true);
      this.$refs.eveningSelector.updateSelected(false);
      this.$refs.morningSelector.updateSelected(false);
      this.$refs.absenceSelector.updateSelected(false);
      this.$refs.otherSelector.updateSelected(false);

      this.$refs.guardSelector.updateSelected(false);
    },
    selectAbsence() {
      this.itemData.type = 'ABSENCE';
      this.$refs.eveningSelector.updateSelected(false);
      this.$refs.morningSelector.updateSelected(false);
      this.$refs.nightSelector.updateSelected(false);
      this.$refs.absenceSelector.updateSelected(true);
      this.$refs.otherSelector.updateSelected(false);

      this.$refs.guardSelector.updateSelected(false);
    },
    selectOther() {
      this.itemData.type = 'OTHER';
      this.$refs.eveningSelector.updateSelected(false);
      this.$refs.morningSelector.updateSelected(false);
      this.$refs.nightSelector.updateSelected(false);
      this.$refs.absenceSelector.updateSelected(false);
      this.$refs.otherSelector.updateSelected(true);

      this.$refs.guardSelector.updateSelected(false);
    },
    selectGuard() {
      this.itemData.type = 'GUARD';
      this.$refs.eveningSelector.updateSelected(false);
      this.$refs.morningSelector.updateSelected(false);
      this.$refs.nightSelector.updateSelected(false);
      this.$refs.absenceSelector.updateSelected(false);
      this.$refs.otherSelector.updateSelected(false);

      this.$refs.guardSelector.updateSelected(true);
    },
    selectBlank() {
      this.itemData.type = 'BLANK';
      this.$refs.eveningSelector.updateSelected(false);
      this.$refs.morningSelector.updateSelected(false);
      this.$refs.nightSelector.updateSelected(false);
      this.$refs.absenceSelector.updateSelected(false);
      this.$refs.otherSelector.updateSelected(false);

      this.$refs.guardSelector.updateSelected(false);

      this.allOptions = [];
      this.options = null;
      this.optionsSelected.codes = [];
    },
    setTabSelected(number) {
      this.tabSelected = number;
    },
    updateTotalIncidences(total) {
      this.totalIncidences = total;
      this.totalIncidencesLoaded = true;
    },
    downloadClockEntries() {
      clockEntryService.downloadClockEntries(this.eventsClock, this.worker, false);
    },
    fetchCalendarEntries() {
      if (!this.workcenter || !this.workcenter.id) return;
      const params = {
        page: 0,
        size: 1000,
        sort: 'date',
        direction: 'asc',
      };
      WorkCenterCalendarService.getCalendarEntriesByWorkCenter(this.workcenter.id, params)
        .then((response) => {
          this.calendarEntries = response.data.content;
          this.updateData();
          this.setupPickerObserver();
        })
        .catch((error) => {
          console.error('Error fetching calendar entries in WorkerMainUI:', error);
        });
    },
    onPickerDateChange(val) {
      this.pickerYearMonth = val;
      this.applyHolidayBackgrounds();
    },
    setupPickerObserver() {
      this.$nextTick(() => {
        const pickerTable = document.querySelector('.view--configure-time .v-date-picker-table--date');
        if (!pickerTable) return;

        if (this.pickerObserver) {
          this.pickerObserver.disconnect();
        }

        this.pickerObserver = new MutationObserver(() => {
          this.applyHolidayBackgrounds();
        });

        this.pickerObserver.observe(pickerTable, {
          childList: true,
          subtree: true,
        });

        this.applyHolidayBackgrounds();
      });
    },
    applyHolidayBackgrounds() {
      /* eslint-disable no-param-reassign */
      this.$nextTick(() => {
        const picker = document.querySelector('.view--configure-time .v-picker--date');
        if (!picker) return;

        let currentYearMonth = this.pickerYearMonth;
        if (!currentYearMonth) {
          currentYearMonth = this.itemData && this.itemData.eventTime
            ? moment(this.itemData.eventTime).format('YYYY-MM')
            : moment().format('YYYY-MM');
        }

        const dayButtons = picker.querySelectorAll('.v-date-picker-table--date tbody button');
        dayButtons.forEach((btn) => {
          if (btn.classList.contains('v-btn--disabled')) return;
          const dayNum = btn.textContent.trim();
          if (!dayNum || Number.isNaN(Number(dayNum))) return;

          const dateStr = `${currentYearMonth}-${String(dayNum).padStart(2, '0')}`;

          if (btn.classList.contains('v-btn--active')) {
            btn.style.backgroundColor = '';
            return;
          }

          const calendarEntry = this.calendarEntries && this.calendarEntries.find((entry) => moment.utc(entry.date).format('YYYY-MM-DD') === dateStr);
          if (calendarEntry && !calendarEntry.available) {
            const bgMap = {
              'FIESTA NACIONAL': '#ffcdd2',
              'FIESTA AUTONOMICA': '#fff9c4',
              'FIESTA LOCAL': '#c8e6c9',
              'FIESTA CONVENIO': '#ffe0b2',
              'AJUSTE HOR. CONVENIO': '#b3e5fc',
              'NO LABORABLE NO RECUP.': '#e1bee7',
            };
            btn.style.backgroundColor = bgMap[calendarEntry.type] || '#eeeeee';
          } else if (!calendarEntry && ConfigureTime.isWeekend(dateStr)) {
            btn.style.backgroundColor = '#eeeeee';
          } else {
            btn.style.backgroundColor = '';
          }
        });
      });
    },
    isWeekendOrHoliday(dateString) {
      if (!dateString) return false;
      const calendarEntry = this.calendarEntries && this.calendarEntries.find((entry) => moment.utc(entry.date).format('YYYY-MM-DD') === dateString);
      if (calendarEntry) {
        return !calendarEntry.available;
      }
      return ConfigureTime.isWeekend(dateString);
    },
    isCodeDisabled(item) {
      if (!item || !this.itemData.eventTime) return false;
      const isWeekend = this.isWeekendOrHoliday(this.itemData.eventTime);
      if (isWeekend) {
        return item.weekend === '0';
      }
      return item.weekend === '1';
    },
  },

};
</script>
<style lang="scss" scoped>
.v-picker--date {
  // margin-bottom: calc(var(--base) * 4);
  z-index: 0;
}

// ::v-deep .theme--light.v-btn.v-btn--disabled,
// .theme--light.v-btn.v-btn--disabled .v-btn__loading,
// .theme--light.v-btn.v-btn--disabled .v-icon {
//   background-color: #f1f1f1;
// }
.page-layout {
  height: 100%;
}

/*add selected with vuetifyColor*/
.selected {
  border: 2px solid var(--color1);
}

.codes-container {
  display: flex;
  flex-direction: column;
  gap: calc(var(--base) * 2);
  overflow-x: hidden;
  grid-column: 1 / span 5;
  width: calc(100% + calc(var(--base) * 6));
  margin-left: calc(var(--base) * -3);
}

//redisign
.view--configure-time {
  //height: 100%;
  height: max-content;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: calc(var(--base) * 0.5);
  margin-top: 40px;
  padding-bottom: 80px;
  margin-bottom: 40px;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(12, 1fr);
  }

  .left-side {
    grid-column: 1 / span 6;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: calc(var(--base) * 4 + 40px);
    gap: calc(var(--base) * 2);

    @media (min-width: 1024px) {
      grid-column: 1 / span 7;
    }
  }

  .right-side {
    grid-column: 1 / span 6;
    height: 100%;
    padding-bottom: 40px;

    @media (min-width: 1024px) {
      grid-column: 8 / span 5;
      padding-left: calc(var(--base) * 3);
    }

    .check-buttons {
      display: flex;
      flex-direction: column;

      .check-buttons--list {
        margin-top: calc(var(--base) * 1);
        display: flex;
        flex-wrap: wrap;
        gap: calc(var(--base) * 2);
      }
    }

    .panel-loader {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }
  }

  .home-grid {
    grid-column: 1 / span 6;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: calc(var(--base) * 2);
    gap: calc(var(--base) * 4);

    @media (min-width: 1024px) {
      grid-column: 1 / span 12;
      display: grid;
      grid-template-columns: 2fr 1fr;
      align-items: center; // Align items centrally across the layout
      justify-items: center; // Center the sections in their 2fr/1fr slots
      gap: calc(var(--base) * 8); // provide a bit more breathing room horizontally
      padding: calc(var(--base) * 4) calc(var(--base) * 8); // extra padding for large screens
      min-height: 60vh;
    }

    @media (min-width: 1400px) {
       grid-template-columns: 3fr 1fr; // Provide even more precedence to left on ultrawide
       padding: calc(var(--base) * 6) calc(var(--base) * 12);
    }

    @media (max-width: 600px) {
      padding: calc(var(--base) * 1);
      gap: calc(var(--base) * 2);
    }
  }

  .home-section-container {
    width: 100%;
    max-width: unset; // Remove max-width constraint to let it fill its grid column
    display: flex;
    flex-direction: column;
    align-items: center; // Centrar contenido de la sección
    gap: calc(var(--base) * 2);

    @media (max-width: 600px) {
      gap: calc(var(--base) * 1);
    }

    &.secondary-section {
      margin-top: calc(var(--base) * 1);
      @media (min-width: 1024px) {
        margin-top: 0; // Disable top margin when on grid alongside the main section
      }
      @media (max-width: 600px) {
        margin-top: 0;
      }
    }
  }

  .home-section-title {
    font-size: calc(var(--base) * 1.6);
    font-weight: 700;
    color: #718096;
    text-transform: uppercase;
    letter-spacing: 2px;
    text-align: center;
    width: 100%;
    margin-bottom: calc(var(--base) * 2);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;

    @media (max-width: 600px) {
      margin-bottom: calc(var(--base) * 0.5);
      font-size: calc(var(--base) * 1.4);
    }

    &::before, &::after {
      content: '';
      height: 1px;
      flex: 1;
      background: rgba(0, 0, 0, 0.08);
      max-width: 40px;
    }
  }

  .home-grid-cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    justify-items: center;
    gap: calc(var(--base) * 3);
    width: 100%;
    max-width: 800px;
    padding: calc(var(--base) * 2);

    &.secondary-grid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      justify-items: center;
      gap: calc(var(--base) * 2);
      width: 100%;
      max-width: 500px;
      margin: 0 auto;

      @media (min-width: 600px) and (max-width: 1023px) {
        grid-template-columns: repeat(3, 1fr);
        gap: calc(var(--base) * 3);
        max-width: 600px;
      }

      @media (min-width: 1024px) {
        grid-template-columns: 1fr; // Stack cards vertically when part of the right side grid
        max-width: 320px; // Cap maximum width so they act like neat vertical buttons
        gap: calc(var(--base) * 3);
        margin: auto; // make sure the entire column is centered within the 1fr column block
      }

      & > * {
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }

    @media (min-width: 768px) and (max-width: 1023px) {
      grid-template-columns: repeat(2, 1fr);
      gap: calc(var(--base) * 5);
    }
    @media (min-width: 1024px) {
      grid-template-columns: repeat(2, 1fr); // Keep main cards in 2 columns inside their 2fr space
      gap: calc(var(--base) * 4);
    }
  }

  .home-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: calc(var(--base) * 2);
    border-radius: 24px !important;
    cursor: pointer;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    aspect-ratio: 1 / 1;
    width: 100%;
    max-width: 280px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.8);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08) !important;
    position: relative;
    text-align: center;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 15px 35px rgba(0,0,0,0.15) !important;
      border-color: var(--color1, var(--v-primary-base, #1976D2));
    }

    h3 {
      margin-top: calc(var(--base) * 2);
      font-size: 1.25rem;
      color: #555;
      font-weight: 600;
      letter-spacing: 0.5px;
    }

    .home-badge {
      position: absolute;
      top: 16px;
      right: 16px;
      background: #FF5252;
      color: white;
      font-size: 14px;
      font-weight: bold;
      min-width: 28px;
      height: 28px;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 6px;
      box-shadow: 0 2px 6px rgba(255, 82, 82, 0.4);
    }
  }
}
</style>
<style lang="scss">
.view--configure-time {
  & .v-picker__body.theme--light {
    margin: 0;
    width: 100% !important;
    padding: calc(var(--base) * 1) calc(var(--base) * 2);
  }

  & .v-date-picker-table .v-btn {
    font-size: calc(var(--base) * 2);
  }

  & .v-picker.v-card.v-picker--date.theme--light {
    height: 100%;
    max-height: calc(var(--layout-height) - calc(var(--base) * 32));
    min-height: calc(var(--layout-height) - calc(var(--base) * 34));

    & table {
      height: 100%;
    }

  }

  & .v-picker__body.theme--light {
    &>div {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  & .v-date-picker-table.v-date-picker-table--date.theme--light {
    height: 100%;
  }

  & .accent--text {
    button {
      font-size: calc(var(--base) * 2.5);
      text-transform: capitalize;
    }
  }

  & .v-date-picker-header.theme--light {
    margin-top: calc(var(--base) * 1);
    margin-bottom: calc(var(--base) * 2);
  }

  & .v-date-picker-title {
    color: #161616;
    text-transform: capitalize;
  }

  & .v-btn.v-btn--active.v-btn--rounded.theme--light.accent {
    background-color: var(--color1) !important;

    & .v-btn__content {
      color: #161616;
    }
  }
}

.floating-menu-container {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: auto;
  padding: 0 16px;

  @media (max-width: 600px) {
    width: 100%;
    bottom: 16px;
  }
}

.floating-menu {
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 8px 16px;
  border-radius: 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.4);
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);

  @media (max-width: 600px) {
    gap: 0;
    justify-content: space-between;
    width: 100%;
    padding: 8px;
    border-radius: 24px;
    box-sizing: border-box;
  }
}

.menu-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border-radius: 24px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  color: #757575;
  outline: none;
  overflow: hidden;

  @media (max-width: 600px) {
    padding: 10px 14px;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--active-bg, var(--v-primary-base, #1976D2));
    opacity: 0;
    transform: scale(0.8);
    border-radius: 24px;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    z-index: -1;
  }

  &.central-action {
    background: transparent;
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    width: 48px;
    height: 48px;
    padding: 0;
    justify-content: center;
    box-shadow: none;
    margin: 0 8px;

    @media (max-width: 600px) {
      width: 44px;
      height: 44px;
      margin: 0 4px;
    }

    &::before {
      display: none;
    }

    &.active {
      background: var(--active-bg, var(--v-primary-base, #1976D2));
      border-color: var(--active-bg, var(--v-primary-base, #1976D2));
      box-shadow: 0 4px 10px rgba(0,0,0,0.2);
      color: white;
    }

    &:hover:not(.active) {
      transform: translateY(-4px) scale(1.05);
      box-shadow: 0 6px 14px rgba(0,0,0,0.1);
      border-color: rgba(0,0,0,0.25);
    }

    &:hover.active {
      transform: translateY(-4px) scale(1.05);
      box-shadow: 0 6px 14px rgba(0,0,0,0.25);
    }

    .label {
      display: none;
    }
  }

  &:hover:not(.active):not(.central-action) {
    background: rgba(0, 0, 0, 0.04);
  }

  &.active {
    color: white;

    &::before {
      opacity: 1;
      transform: scale(1);
    }

    .label {
      max-width: 100px;
      opacity: 1;
      margin-left: 8px;
      transform: translateX(0);
    }
  }

  .icon-wrapper {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
  }

  .badge {
    position: absolute;
    top: -6px;
    right: -10px;
    background: #FF5252;
    color: white;
    font-size: 10px;
    font-weight: bold;
    min-width: 18px;
    height: 18px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 4px;
    border: 2px solid white;
    box-shadow: 0 2px 4px rgba(255, 82, 82, 0.4);
  }

  .label {
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    max-width: 0;
    opacity: 0;
    transform: translateX(-10px);
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    z-index: 1;

    @media (max-width: 600px) {
      display: none; // hide text on very small screens even when active to save space
      margin: 0;
    }
  }
}
  .section-header{
    margin-bottom: calc(var(--base)* 1.5)!important;
    margin-top: calc(var(--base)* 1.5) !important;
  }
  .row-month-selection{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .custom-disabled-card {
    background-color: #eaeaea !important;
    color: #999999 !important;
    border: 2px dashed #cccccc !important;
    cursor: not-allowed !important;
    pointer-events: none !important;

    .code-card--title {
      color: #888888 !important;
    }
    .code-card--description {
      color: #aaaaaa !important;
    }
  }

  .custom-disabled-card-clickable {
    background-color: #ffdcdb !important;
    color: #b71c1c !important;
    border: 2px dashed #e57373 !important;

    .code-card--title {
      color: #b71c1c !important;
    }
    .code-card--description {
      color: #c62828 !important;
    }
  }
</style>
